import { createPinia } from "pinia";
import { useGlobalStore } from "./modules/global";

const pinia = createPinia();

export { useGlobalStore };
export default pinia;
